import { ProductiveAnimalDTO } from 'src/dto/animal.dto'

interface CalculateWeightingParams {
  productiveAnimalHistoric: ProductiveAnimalDTO[]
  newWeight: number
  newDate: string
}

interface WeightingResult {
  gpd: number
  gpm: number
  inter: number
  lastWeightEntry?: ProductiveAnimalDTO | null
}

/**
 * Calcula GPD, GPM e INTER com base no histórico produtivo do animal
 * Função pura (não depende de React)
 */
export function calculateWeighting({
  productiveAnimalHistoric,
  newDate,
  newWeight
}: CalculateWeightingParams): WeightingResult {
  // Caso não exista histórico, não há como calcular ganho
  if (!productiveAnimalHistoric.length) {
    return {
      gpd: 0,
      gpm: 0,
      inter: 0
    }
  }

  // Ordena histórico por data (mais antigo → mais recente)
  const orderedHistoric = [...productiveAnimalHistoric].sort(
    (a, b) => new Date(a.data).getTime() - new Date(b.data).getTime()
  )

  const lastRecord = orderedHistoric[orderedHistoric.length - 1]

  // Diferença de dias entre a última pesagem e a atual
  const diffTime = new Date(newDate).getTime() - new Date(lastRecord.data).getTime()

  const diffDays = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 1)

  // Diferença de peso
  const diffWeight = newWeight - lastRecord.peso

  // GPD = Ganho de Peso Diário
  const gpd = Number((diffWeight / diffDays).toFixed(3))

  // GPM = Ganho de Peso Mensal (30 dias)
  const gpm = Number((gpd * 30).toFixed(2))

  // INTER = intervalo entre pesagens (dias)
  const inter = diffDays

  return {
    gpd,
    gpm,
    inter,
    lastWeightEntry: lastRecord
  }
}

export const parseNumber = (value?: string | null): number | null => {
  if (!value) return null

  const normalized = value
    .replace(/\./g, '') // remove separador de milhar
    .replace(',', '.') // troca vírgula por ponto

  const parsed = Number(normalized)

  return isNaN(parsed) ? null : parsed
}
